import { createTheme } from "@mui/material/styles";

const getTheme = (mode) =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: "#6241d4",
        light: "#8a6cd4",
        dark: "#452d9b",
      },
      secondary: {
        main: "#00c4b5",
        light: "#33d0c4",
        dark: "#008a80",
      },
      background: {
        default: mode === "light" ? "#ffffff" : "#0e1525",
        paper: mode === "light" ? "#ffffff" : "#0e1525",
      },
      text: {
        primary: mode === "light" ? "#282a2c" : "#ffffff",
        secondary: mode === "light" ? "#707274" : "#b6b9bb",
      },
    },
    typography: {
      fontFamily: '"Geist Sans", "IBM Plex Sans", "Inter", sans-serif',
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          html: {
            fontFamily: '"Geist Sans", "IBM Plex Sans", "Inter", sans-serif',
          },
          body: {
            fontFamily: '"Geist Sans", "IBM Plex Sans", "Inter", sans-serif',
            fontSize: "14px",
            backgroundColor: "var(--background-primary)",
            color: "var(--text-primary)",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundColor: "var(--background-primary)",
            backgroundImage: "none"
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: "var(--background-secondary)",
            color: "var(--text-primary)",
            border: "1px solid var(--borderColor)"
          },
          arrow: {
            "&::before": {
              backgroundColor: "var(--background-secondary)",
              border: "1px solid var(--borderColor)",
              boxSizing: "border-box"
            }
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: "var(--background-primary)",
            borderRadius: "12px",
            boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.2)",
            backgroundImage: "none",
            border: "1px solid var(--borderColor)"
          },
        },
      },
    },
  });

export default getTheme;
